(function () {
  'use strict';

  function formatWithDelimiters(number, precision, thousands, decimal) {
    if (isNaN(number) || number == null) return '0';
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.');
    var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var centsAmount = parts[1] ? decimal + parts[1] : '';
    return dollarsAmount + centsAmount;
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10);
    if (isNaN(cents)) cents = 0;

    var formatString = format || '${{amount}}';
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, formatString);
    }

    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = formatString.match(placeholderRegex);
    var placeholder = match ? match[1] : 'amount';
    var value = '';

    switch (placeholder) {
      case 'amount':
        value = formatWithDelimiters(cents, 2, ',', '.');
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ', '.');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2, ',', '.');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  function getMoneyFormat(data) {
    if (window.baCurr && window.baCurr.config && window.baCurr.config.money_format) {
      return window.baCurr.config.money_format;
    }
    if (typeof Shopify !== 'undefined') {
      if (Shopify.currency && Shopify.currency.money_format) {
        return Shopify.currency.money_format;
      }
      if (Shopify.money_format) {
        return Shopify.money_format;
      }
    }
    return (data && data.moneyFormat) || '${{amount}}';
  }

  function setMoneyHtml(el, cents, format) {
    if (!el) return;
    el.innerHTML = formatMoney(cents, format);
  }

  function hookCurrencyRefresh(callback) {
    function install() {
      if (!window.baCurr) return false;
      var prev = window.baCurr.rePeat;
      if (prev && prev.__customPdpHooked) return true;
      window.baCurr.rePeat = function () {
        if (typeof prev === 'function') prev.apply(this, arguments);
        callback();
      };
      window.baCurr.rePeat.__customPdpHooked = true;
      return true;
    }

    if (!install()) {
      var tries = 0;
      var timer = window.setInterval(function () {
        if (install() || ++tries >= 40) window.clearInterval(timer);
      }, 250);
    }
  }

  var BUNDLE_PROP_KEY = '_bundle';
  var BUNDLE_CODE_STORAGE_KEY = 'missleather_bundle_discount_code';

  function cartRootPath() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function isThemeDevHost() {
    var host = window.location.hostname;
    return host === '127.0.0.1' || host === 'localhost';
  }

  function rememberBundleDiscountCode(code) {
    if (!code) return;
    try {
      window.sessionStorage.setItem(BUNDLE_CODE_STORAGE_KEY, code);
    } catch (e) {
      /* private mode */
    }
  }

  function getRememberedBundleDiscountCode() {
    try {
      return (window.sessionStorage.getItem(BUNDLE_CODE_STORAGE_KEY) || '').trim();
    } catch (e) {
      return '';
    }
  }

  function cartHasBundle(cart) {
    if (!cart || !cart.items || !cart.items.length) return false;
    return cart.items.some(function (item) {
      var props = item.properties || {};
      return String(props[BUNDLE_PROP_KEY] || '') === '1';
    });
  }

  function fetchCart() {
    return fetch(cartRootPath().replace(/\/?$/, '/') + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (res) {
      return res.json();
    });
  }

  function discountRedirectUrl(code, redirectPath) {
    var redirect = redirectPath || '/cart';
    if (redirect.charAt(0) !== '/') redirect = '/' + redirect;

    /* Local theme server cannot apply discounts (401). Use the real shop host when known. */
    if (isThemeDevHost()) {
      var shop = (window.Shopify && (Shopify.shop || Shopify.permanent_domain)) || '';
      if (shop) {
        return (
          'https://' +
          shop +
          '/discount/' +
          encodeURIComponent(code) +
          '?redirect=' +
          encodeURIComponent(redirect)
        );
      }
      return null;
    }

    var root = cartRootPath().replace(/\/?$/, '/');
    return (
      root +
      'discount/' +
      encodeURIComponent(code) +
      '?redirect=' +
      encodeURIComponent(redirect)
    );
  }

  function navigateWithBundleDiscount(redirectPath, code) {
    var path = redirectPath || '/cart';
    return fetchCart().then(function (cart) {
      var discountCode = (code || getRememberedBundleDiscountCode() || '').trim();
      if (!(cartHasBundle(cart) && discountCode)) return false;

      rememberBundleDiscountCode(discountCode);

      /* Localhost cart session cannot follow a production discount URL with the same cart. */
      if (isThemeDevHost()) {
        return false;
      }

      var url = discountRedirectUrl(discountCode, path);
      if (!url) return false;
      window.location.href = url;
      return true;
    });
  }

  function refreshThemeCartDrawer() {
    var configEl = document.getElementById('cart-config');
    if (!configEl || typeof Shopify === 'undefined' || !Shopify.theme || !Shopify.theme.ajaxCart) {
      return Promise.resolve(false);
    }

    var config;
    try {
      config = JSON.parse(configEl.textContent || '{}');
    } catch (e) {
      return Promise.resolve(false);
    }

    return fetchCart()
      .then(function (cart) {
        if (typeof Shopify.theme.ajaxCart.updateView === 'function') {
          Shopify.theme.ajaxCart.updateView(config, cart);
        }
        if (config.cart_action === 'drawer' && typeof Shopify.theme.ajaxCart.showDrawer === 'function') {
          Shopify.theme.ajaxCart.showDrawer(config);
        } else if (config.cart_action === 'modal_cart' && typeof Shopify.theme.ajaxCart.showModal === 'function') {
          Shopify.theme.ajaxCart.showModal(config);
        }
        return true;
      })
      .catch(function () {
        return false;
      });
  }

  function goToCartOrDrawer() {
    return refreshThemeCartDrawer().then(function (opened) {
      if (!opened) window.location.href = cartRootPath().replace(/\/?$/, '/') + 'cart';
      return opened;
    });
  }

  function initBundle(root, data, helpers) {
    var bundle = root.querySelector('[data-bundle]');
    if (!bundle) return;

    var discount = parseFloat(data.bundleDiscount);
    if (isNaN(discount) || discount < 0) discount = 0;
    if (discount > 1) discount = discount / 100;

    var discountCode = (data.bundleDiscountCode || bundle.dataset.bundleDiscountCode || '').trim();
    var bunNow = bundle.querySelector('[data-bun-now]');
    var bunWas = bundle.querySelector('[data-bun-was]');
    var bunSave = bundle.querySelector('[data-bun-save]');
    var addBtn = bundle.querySelector('[data-bundle-add]');
    var msgEl = bundle.querySelector('[data-bundle-msg]');
    var mainWrap = bundle.querySelector('[data-bundle-main]');
    var addLabel = addBtn ? addBtn.textContent : 'Add bundle to cart';
    var sizesWrap = root.querySelector('[data-sizes]');

    function parseItemVariants(itemEl) {
      var script = itemEl.querySelector('[data-bundle-variants]');
      if (!script) return [];
      try {
        return JSON.parse(script.textContent || '[]');
      } catch (e) {
        return [];
      }
    }

    function findBestVariant(variants, sizeIdx, sizeValue) {
      if (!variants.length) return null;
      if (sizeIdx < 0 || !sizeValue) {
        return (
          variants.find(function (v) {
            return v.available;
          }) || variants[0]
        );
      }

      var exact = variants.filter(function (v) {
        return v.options[sizeIdx] === sizeValue;
      });
      if (!exact.length) return null;
      return (
        exact.find(function (v) {
          return v.available;
        }) || exact[0]
      );
    }

    function applyVariantToItem(itemEl, variant) {
      if (!itemEl || !variant) return;
      var input = itemEl.querySelector('input[type="checkbox"]');
      var priceEl = itemEl.querySelector('[data-bi-price]');
      if (input) {
        input.dataset.price = variant.price;
        input.dataset.variantId = variant.id;
        input.dataset.available = variant.available ? 'true' : 'false';
        if (!variant.available) {
          input.checked = false;
          input.disabled = true;
          itemEl.classList.add('bi--unavailable');
        } else {
          input.disabled = false;
          itemEl.classList.remove('bi--unavailable');
        }
      }
      if (priceEl) setMoneyHtml(priceEl, variant.price, getMoneyFormat(data));
    }

    function initBundleItem(itemEl) {
      var select = itemEl.querySelector('[data-bundle-size]');
      if (!select) return;

      var variants = parseItemVariants(itemEl);
      var sizeIdx = parseInt(select.dataset.sizeOptionIndex || '-1', 10);

      select.addEventListener('change', function () {
        var variant = findBestVariant(variants, sizeIdx, select.value);
        if (variant) applyVariantToItem(itemEl, variant);
        recalcBundle();
      });
    }

    function getMainSizeValue() {
      if (!sizesWrap) return '';
      var on = sizesWrap.querySelector('.sz.on, [data-option-value].on');
      return on ? String(on.dataset.optionValue || '').trim() : '';
    }

    function syncAddonSizesFromMain() {
      var mainSize = getMainSizeValue();
      if (!mainSize) return;

      bundle.querySelectorAll('[data-bundle-item]:not([data-bundle-main])').forEach(function (itemEl) {
        var select = itemEl.querySelector('[data-bundle-size]');
        if (!select) return;

        var sizeIdx = parseInt(select.dataset.sizeOptionIndex || '-1', 10);
        var hasOption = Array.prototype.some.call(select.options, function (opt) {
          return opt.value === mainSize;
        });
        if (!hasOption) return;

        select.value = mainSize;
        var variant = findBestVariant(parseItemVariants(itemEl), sizeIdx, mainSize);
        if (variant) applyVariantToItem(itemEl, variant);
      });
      recalcBundle();
    }

    function getChecks() {
      return Array.prototype.slice
        .call(bundle.querySelectorAll('[data-bundle-item] input[type="checkbox"]'))
        .filter(function (input) {
          if (!input.checked || !input.dataset.variantId) return false;
          return input.dataset.available !== 'false';
        });
    }

    function recalcBundle() {
      var moneyFormat = getMoneyFormat(data);
      var subtotal = 0;
      getChecks().forEach(function (input) {
        subtotal += parseInt(input.dataset.price, 10) || 0;
      });

      var total = Math.round(subtotal * (1 - discount));
      var save = subtotal - total;

      if (bunNow) setMoneyHtml(bunNow, total, moneyFormat);
      if (bunWas) {
        if (save > 0) {
          setMoneyHtml(bunWas, subtotal, moneyFormat);
          bunWas.style.display = '';
        } else {
          bunWas.style.display = 'none';
        }
      }
      if (bunSave) {
        if (save > 0) {
          bunSave.innerHTML = 'Save ' + formatMoney(save, moneyFormat);
          bunSave.style.display = '';
        } else {
          bunSave.style.display = 'none';
        }
      }
      if (addBtn) addBtn.disabled = getChecks().length === 0;
    }

    function syncMainProduct(variant) {
      if (!mainWrap || !variant) return;
      var input = mainWrap.querySelector('input[type="checkbox"]');
      var priceEl = mainWrap.querySelector('[data-bi-price]');
      if (input) {
        input.dataset.price = variant.price;
        input.dataset.variantId = variant.id;
      }
      if (priceEl) setMoneyHtml(priceEl, variant.price, getMoneyFormat(data));
      syncAddonSizesFromMain();
    }

    function showBundleMsg(text, type) {
      if (!msgEl) return;
      msgEl.textContent = text || '';
      msgEl.classList.remove('is-error', 'is-success', 'visually-hidden');
      if (!text) {
        msgEl.classList.add('visually-hidden');
        return;
      }
      msgEl.classList.add(type === 'error' ? 'is-error' : 'is-success');
    }

    function applyBundleDiscountCode() {
      if (!discountCode) return Promise.resolve(false);
      rememberBundleDiscountCode(discountCode);

      if (isThemeDevHost()) {
        showBundleMsg(
          'Bundle added. Discount codes do not apply on localhost — test on the live store URL.',
          'success'
        );
        return goToCartOrDrawer().then(function () {
          return false;
        });
      }

      var url = discountRedirectUrl(discountCode, '/cart');
      if (!url) {
        return goToCartOrDrawer().then(function () {
          return false;
        });
      }
      window.location.href = url;
      return Promise.resolve(true);
    }

    bundle.querySelectorAll('[data-bundle-item]').forEach(initBundleItem);

    bundle.addEventListener('change', function (e) {
      if (e.target.matches('input[type="checkbox"]') || e.target.matches('[data-bundle-size]')) {
        recalcBundle();
      }
    });

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var missingSize = false;
        bundle.querySelectorAll('[data-bundle-item]:not([data-bundle-main])').forEach(function (itemEl) {
          var select = itemEl.querySelector('[data-bundle-size]');
          var input = itemEl.querySelector('input[type="checkbox"]');
          if (input && input.checked && select && !select.value) missingSize = true;
        });
        if (missingSize) {
          showBundleMsg('Choose a size for each bundle item.', 'error');
          return;
        }

        var items = getChecks()
          .map(function (input) {
            return {
              id: parseInt(input.dataset.variantId, 10),
              quantity: 1,
              properties: { _bundle: '1' }
            };
          })
          .filter(function (item) {
            return item.id > 0;
          });

        if (!items.length) {
          showBundleMsg('Select at least one item for the bundle.', 'error');
          return;
        }

        showBundleMsg('', '');
        addBtn.disabled = true;
        addBtn.textContent = 'Adding…';

        var cartRoot = cartRootPath();
        fetch(cartRoot.replace(/\/?$/, '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: items })
        })
          .then(function (res) {
            return res.json().then(function (body) {
              if (!res.ok) throw body;
              return body;
            });
          })
          .then(function () {
            if (discountCode) {
              showBundleMsg('Bundle added — applying discount…', 'success');
              return applyBundleDiscountCode();
            }
            showBundleMsg('Bundle added to cart.', 'success');
            return goToCartOrDrawer();
          })
          .catch(function (err) {
            var message =
              (err && err.description) || (err && err.message) || 'Could not add bundle. Try again.';
            showBundleMsg(message, 'error');
          })
          .finally(function () {
            if (!discountCode) {
              addBtn.disabled = getChecks().length === 0;
              addBtn.textContent = addLabel;
            }
          });
      });
    }

    helpers.syncMainProduct = syncMainProduct;
    helpers.syncAddonSizesFromMain = syncAddonSizesFromMain;
    syncAddonSizesFromMain();
    recalcBundle();
  }

  function measurePinTop() {
    var pinTop = 0;
    document
      .querySelectorAll('.websensepro-announcement-bar, .announcement__bar-section, .header-section')
      .forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.height > 0 && rect.top < window.innerHeight && rect.bottom > pinTop) {
          pinTop = rect.bottom;
        }
      });
    return Math.round(pinTop);
  }

  function syncStickyOffsets() {
    document.documentElement.style.setProperty('--custom-pdp-sticky-top', measurePinTop() + 'px');
  }

  function isPurchaseControl(el) {
    return !!(
      el &&
      el.closest(
        '[data-qty-minus], [data-qty-plus], [data-qty-display], [data-qty-input], [data-add-btn], .qty, .add-big, .pay-row, .shopify-payment-button'
      )
    );
  }

  function layoutMiskFields(miskSlot) {
    if (!miskSlot) return;

    miskSlot.querySelectorAll('a').forEach(function (link) {
      var label = (link.textContent || '').toLowerCase();
      if (label.indexOf('measure') === -1) return;
      var wrapper = link.closest('.misk-option-wrapper');
      if (wrapper) wrapper.classList.add('custom-pdp-misk-guide');
    });
  }

  function isolateMiskLayout(root) {
    var purchasePanel = root.querySelector('[data-purchase-panel]');
    var optionsPanel = root.querySelector('[data-options-panel]');
    var miskSlot = root.querySelector('[data-misk-slot]');
    var fitPanel = root.querySelector('[data-fit-panel]');
    var addRow = root.querySelector('[data-sticky-trigger]');
    if (!miskSlot || !purchasePanel || !addRow) return;

    if (!miskSlot.querySelector('#misk-product-options-block')) {
      var mount = document.createElement('div');
      mount.id = 'misk-product-options-block';
      miskSlot.insertBefore(mount, miskSlot.firstChild);
    }

    if (fitPanel && optionsPanel && fitPanel.parentElement === optionsPanel.parentElement) {
      if (optionsPanel.compareDocumentPosition(fitPanel) & Node.DOCUMENT_POSITION_FOLLOWING) {
        /* options panel already precedes fit panel */
      } else {
        fitPanel.parentElement.insertBefore(optionsPanel, fitPanel);
      }
    }

    if (addRow.parentElement !== purchasePanel) {
      purchasePanel.insertBefore(addRow, purchasePanel.firstChild);
    }

    var payRow = root.querySelector('[data-payment-wrap]');
    if (payRow && payRow.parentElement !== purchasePanel) {
      purchasePanel.appendChild(payRow);
    }

    root.querySelectorAll('[data-misk-portal-host]').forEach(function (host) {
      if (purchasePanel.contains(host) || addRow.contains(host)) {
        host.style.display = 'none';
      }
    });

    purchasePanel.querySelectorAll('.misk-product-options').forEach(function (options) {
      if (!isPurchaseControl(options) && !miskSlot.contains(options)) {
        miskSlot.appendChild(options);
      }
    });

    if (fitPanel) {
      var sibling = fitPanel.nextElementSibling;
      while (sibling && !sibling.matches('[data-purchase-panel], .custom-pdp-buy-zone')) {
        var next = sibling.nextElementSibling;
        if (
          sibling.matches('.misk-product-options, [class*="misk-"]') ||
          sibling.querySelector('.misk-option-wrapper, .misk-product-options')
        ) {
          if (!isPurchaseControl(sibling) && !miskSlot.contains(sibling)) {
            miskSlot.appendChild(sibling);
          }
        }
        sibling = next;
      }
    }

    layoutMiskFields(miskSlot);
  }

  function initMiskLayoutWatch(root) {
    if (root.dataset.miskLayoutWatch === 'true') return;
    root.dataset.miskLayoutWatch = 'true';

    var run = function () {
      isolateMiskLayout(root);
    };

    run();
    window.setTimeout(run, 120);
    window.setTimeout(run, 500);
    window.setTimeout(run, 1200);

    var form = root.querySelector('[data-product-form]');
    if (form && typeof MutationObserver !== 'undefined') {
      var timer = null;
      var observer = new MutationObserver(function () {
        window.clearTimeout(timer);
        timer = window.setTimeout(run, 60);
      });
      observer.observe(form, { childList: true, subtree: true });
    }
  }

  function initStickyBar(root) {
    if (!root || root.dataset.stickyBarInit === 'true') return;
    root.dataset.stickyBarInit = 'true';

    var sectionId = root.dataset.sectionId;
    var sticky =
      root.querySelector('[data-sticky]') ||
      document.querySelector('[data-sticky-for="' + sectionId + '"]');
    if (!sticky) return;

    if (sticky.parentElement !== document.body) {
      document.body.appendChild(sticky);
    }

    function getTrigger() {
      return (
        root.querySelector('[data-sticky-trigger]') ||
        root.querySelector('.add-row') ||
        root.querySelector('[data-add-btn]')
      );
    }

    function setShow(show) {
      sticky.classList.toggle('show', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    var stickyObserver = null;

    function updateStickyBar() {
      syncStickyOffsets();

      var trigger = getTrigger();
      if (!trigger) return;

      var pin = measurePinTop();
      var rect = trigger.getBoundingClientRect();
      var show = rect.bottom <= pin + 2 || rect.top < pin + 2;
      setShow(show);
    }

    function bindObserver() {
      var trigger = getTrigger();
      if (!trigger || typeof IntersectionObserver === 'undefined') return;
      if (stickyObserver) stickyObserver.disconnect();
      var pin = measurePinTop();
      stickyObserver = new IntersectionObserver(
        function () {
          updateStickyBar();
        },
        { threshold: 0, rootMargin: '-' + pin + 'px 0px 0px 0px' }
      );
      stickyObserver.observe(trigger);
    }

    var stAdd = sticky.querySelector('[data-sticky-add]');
    if (stAdd) {
      stAdd.addEventListener('click', function () {
        var form = root.querySelector('[data-product-form]');
        if (!form) return;
        if (typeof root._validateMadeToMeasure === 'function' && !root._validateMadeToMeasure(true)) {
          return;
        }
        if (form.requestSubmit) form.requestSubmit();
        else form.submit();
      });
    }

    var onScroll = function () {
      updateStickyBar();
    };

    bindObserver();
    updateStickyBar();
    requestAnimationFrame(updateStickyBar);
    setTimeout(updateStickyBar, 250);

    window.addEventListener('scroll', onScroll, { passive: true, capture: true });
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', function () {
      bindObserver();
      updateStickyBar();
    });
    document.addEventListener('shopify:section:load', updateStickyBar);

    root._updateStickyBar = updateStickyBar;
  }

  var DEFAULT_WAIST_BY_SIZE = {
    XS: 20,
    S: 22,
    M: 24,
    L: 26,
    XL: 28,
    '2XL': 30,
    '3XL': 32,
    '4XL': 34,
    '5XL': 36,
    '6XL': 38,
    '7XL': 40
  };

  var FIT_REDUCTION = {
    everyday: 3,
    training: 4,
    occasion: 2
  };

  function initSizeChartModal(root) {
    var modal = root.querySelector('[data-size-chart-modal]');
    if (!modal) return;

    var openBtns = root.querySelectorAll('[data-size-chart-open]');
    var closeBtns = modal.querySelectorAll('[data-size-chart-close]');
    var dialog = modal.querySelector('.custom-pdp-size-chart-modal__dialog');
    var lastFocus = null;

    function openModal(trigger) {
      lastFocus = trigger || document.activeElement;
      modal.removeAttribute('hidden');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('custom-pdp-modal-open');
      var closeBtn = modal.querySelector('.custom-pdp-size-chart-modal__close');
      if (closeBtn) closeBtn.focus();
    }

    function closeModal() {
      modal.setAttribute('hidden', '');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('custom-pdp-modal-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    openBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        openModal(btn);
      });
    });

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });

    modal.addEventListener('click', function (e) {
      if (e.target === modal.querySelector('.custom-pdp-size-chart-modal__backdrop')) {
        closeModal();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || modal.hasAttribute('hidden')) return;
      closeModal();
    });

    if (dialog) {
      dialog.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var focusable = dialog.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      });
    }

    return { openModal: openModal, closeModal: closeModal };
  }

  function initFitCalculator(root, data, helpers) {
    var fitPanel = root.querySelector('[data-fit-panel]');
    var findBtn = root.querySelector('[data-find-my-size]');
    if (!fitPanel) return;

    var waistInput = fitPanel.querySelector('[data-fit-waist]');
    var purposeSelect = fitPanel.querySelector('[data-fit-purpose]');
    var submitBtn = fitPanel.querySelector('[data-fit-submit]');
    var resultEl = fitPanel.querySelector('[data-fit-result]');
    var waistChart = data.waistBySize && Object.keys(data.waistBySize).length ? data.waistBySize : DEFAULT_WAIST_BY_SIZE;

    fitPanel.classList.add('is-open');
    fitPanel.removeAttribute('hidden');

    function openFitPanel() {
      fitPanel.removeAttribute('hidden');
      fitPanel.classList.add('is-open');
      if (fitPanel.scrollIntoView) {
        fitPanel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
      if (waistInput) waistInput.focus();
    }

    function getWaistInches() {
      if (!waistInput) return 0;
      var value = parseFloat(waistInput.value);
      if (isNaN(value) || value <= 0) return 0;
      return value;
    }

    function recommendSize() {
      var waist = getWaistInches();
      if (!waist || !resultEl || !purposeSelect) return;

      var purpose = purposeSelect.value || 'training';
      var reduction = FIT_REDUCTION[purpose] || 4;
      var targetClosed = waist - reduction;
      var bestSize = null;
      var bestClosed = null;
      var minDiff = Infinity;

      Object.keys(waistChart).forEach(function (size) {
        var closed = parseFloat(waistChart[size]);
        if (isNaN(closed)) return;
        var diff = Math.abs(closed - targetClosed);
        if (diff < minDiff) {
          minDiff = diff;
          bestSize = size;
          bestClosed = closed;
        }
      });

      if (!bestSize || bestClosed == null) return;

      var purposeLabel = purposeSelect.options[purposeSelect.selectedIndex]
        ? purposeSelect.options[purposeSelect.selectedIndex].text
        : 'waist training';
      var actualReduction = Math.round((waist - bestClosed) * 10) / 10;
      var waistDisplay = Math.round(waist * 10) / 10;

      resultEl.innerHTML =
        'For a <b>' +
        waistDisplay +
        '"</b> waist worn for <b>' +
        purposeLabel.toLowerCase() +
        '</b>, we recommend size <b>' +
        bestSize +
        '</b> (≈' +
        bestClosed +
        '" closed waist, a ' +
        actualReduction +
        '" reduction). Between sizes? <b>Size up.</b>';
      resultEl.classList.add('show');

      if (helpers.sizesWrap && helpers.selectOption) {
        var sizeIdx = parseInt(helpers.sizesWrap.dataset.optionIndex || '-1', 10);
        if (sizeIdx >= 0) {
          var matchedValue = bestSize;
          var sizeBtn = Array.prototype.find.call(
            helpers.sizesWrap.querySelectorAll('[data-option-value]'),
            function (el) {
              return String(el.dataset.optionValue || '').toUpperCase() === String(bestSize).toUpperCase();
            }
          );
          if (sizeBtn) matchedValue = sizeBtn.dataset.optionValue;
          helpers.selectOption(sizeIdx, matchedValue);
        }
      }
    }

    root.syncJobToFitPurpose = function (jobText) {
      if (!purposeSelect || !jobText) return;
      var text = jobText.toLowerCase();
      if (text.indexOf('train') !== -1) purposeSelect.value = 'training';
      else if (text.indexOf('fashion') !== -1 || text.indexOf('every') !== -1) purposeSelect.value = 'everyday';
      else if (text.indexOf('occasion') !== -1) purposeSelect.value = 'occasion';
    };

    function syncJobToFitPurpose(jobText) {
      root.syncJobToFitPurpose(jobText);
    }

    if (findBtn) {
      findBtn.addEventListener('click', openFitPanel);
    }

    if (submitBtn) {
      submitBtn.addEventListener('click', recommendSize);
    }

    if (waistInput) {
      waistInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          recommendSize();
        }
      });
    }

    var activeJob = root.querySelector('[data-jobs] .job.on');
    if (activeJob) syncJobToFitPurpose(activeJob.textContent || '');

    return { openFitPanel: openFitPanel, recommendSize: recommendSize };
  }

  function initPaymentRow(root) {
    var payRow = root.querySelector('[data-payment-wrap]');
    if (!payRow) return;

    var staticGrid = payRow.querySelector('[data-pay-exp-grid]');
    var payLive = payRow.querySelector('[data-pay-live]');
    var productForm = root.querySelector('[data-product-form]');

    function refreshCheckoutButtons() {
      if (typeof Shopify !== 'undefined' && Shopify.PaymentButton && typeof Shopify.PaymentButton.init === 'function') {
        Shopify.PaymentButton.init();
      }
    }

    function getVariantId() {
      var input = root.querySelector('[data-variant-id]');
      return input ? parseInt(input.value, 10) : 0;
    }

    function getQuantity() {
      var qtyInput = root.querySelector('[data-qty-input]');
      var qtyDisplay = root.querySelector('[data-qty-display]');
      if (qtyInput && qtyInput.value) return parseInt(qtyInput.value, 10) || 1;
      if (qtyDisplay) return parseInt(qtyDisplay.textContent, 10) || 1;
      return 1;
    }

    function getLineItemProperties() {
      var properties = {};
      if (!productForm) return properties;

      productForm
        .querySelectorAll('input[name^="properties["], textarea[name^="properties["], select[name^="properties["]')
        .forEach(function (el) {
          if (!el.name || el.disabled) return;
          var match = el.name.match(/^properties\[(.+)\]$/);
          if (!match) return;
          var val = (el.value || '').trim();
          if (val) properties[match[1]] = val;
        });

      return properties;
    }

    function isThemeDevHost() {
      var host = window.location.hostname;
      return host === '127.0.0.1' || host === 'localhost';
    }

    function syncCheckoutForm() {
      var variantInput = root.querySelector('[data-variant-id]');
      var qtyInput = root.querySelector('[data-qty-input]');
      var id = getVariantId();
      var quantity = getQuantity();

      if (variantInput && id) {
        variantInput.value = String(id);
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (qtyInput) qtyInput.value = String(quantity);
    }

    function triggerMorePaymentOptions() {
      if (!payLive) return false;

      var moreBtn = payLive.querySelector(
        'button.shopify-payment-button__more-options, .shopify-payment-button__more-options'
      );
      if (!moreBtn || moreBtn.classList.contains('shopify-payment-button__button--hidden')) {
        return false;
      }

      moreBtn.click();
      return true;
    }

    function addToCartThenNavigate() {
      var id = getVariantId();
      if (!id) return Promise.reject(new Error('No variant selected'));

      var item = { id: id, quantity: getQuantity() };
      var props = getLineItemProperties();
      if (Object.keys(props).length) item.properties = props;

      var cartRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      return fetch(cartRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [item] })
      }).then(function (res) {
        return res.json().then(function (body) {
          if (!res.ok) throw body;
          window.location.href = cartRoot + 'cart';
        });
      });
    }

    function goToAlternatePayment(triggerBtn) {
      if (typeof root._validateMadeToMeasure === 'function' && !root._validateMadeToMeasure(true)) {
        return;
      }

      syncCheckoutForm();
      refreshCheckoutButtons();

      if (triggerBtn) triggerBtn.disabled = true;

      function finishFallback() {
        addToCartThenNavigate()
          .catch(function () {
            if (productForm && typeof productForm.requestSubmit === 'function') {
              productForm.requestSubmit();
            }
          })
          .finally(function () {
            if (triggerBtn) triggerBtn.disabled = false;
          });
      }

      if (isThemeDevHost()) {
        finishFallback();
        return;
      }

      if (triggerMorePaymentOptions()) {
        window.setTimeout(function () {
          if (triggerBtn) triggerBtn.disabled = false;
        }, 1200);
        return;
      }

      window.setTimeout(function () {
        if (triggerMorePaymentOptions()) {
          window.setTimeout(function () {
            if (triggerBtn) triggerBtn.disabled = false;
          }, 1200);
          return;
        }
        finishFallback();
      }, 350);
    }

    function wireAlternateWallets() {
      if (!staticGrid || staticGrid.dataset.payExpInit === 'true') return;
      staticGrid.dataset.payExpInit = 'true';

      staticGrid.querySelectorAll('[data-pay-exp]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          goToAlternatePayment(btn);
        });
      });
    }

    function detectLegacyWallets() {
      if (!payLive) return false;
      return !!payLive.querySelector(
        '#dynamic-checkout-cart ul li, .wallet-cart-grid .wallet-cart-button-container'
      );
    }

    function applyLayout() {
      if (detectLegacyWallets()) {
        payRow.classList.add('is-legacy-wallets');
        payRow.classList.remove('is-single-wallet');
        if (payLive && payLive.parentElement !== payRow) {
          payRow.appendChild(payLive);
        }
        if (staticGrid) staticGrid.hidden = true;
        return;
      }

      payRow.classList.add('is-single-wallet');
      payRow.classList.remove('is-legacy-wallets');
      if (staticGrid) staticGrid.hidden = false;

      var shopSlot = payRow.querySelector('[data-pay-slot="shop"]');
      if (payLive && shopSlot && payLive.parentElement !== shopSlot) {
        shopSlot.appendChild(payLive);
      }
    }

    wireAlternateWallets();
    applyLayout();
    refreshCheckoutButtons();

    if (payLive) {
      payLive.addEventListener(
        'click',
        function (e) {
          if (typeof root._validateMadeToMeasure === 'function' && !root._validateMadeToMeasure(true)) {
            e.preventDefault();
            e.stopPropagation();
          }
        },
        true
      );
    }

    window.setTimeout(refreshCheckoutButtons, 400);
    window.setTimeout(function () {
      refreshCheckoutButtons();
      applyLayout();
    }, 1200);

    if (typeof MutationObserver !== 'undefined' && payLive) {
      var timer = null;
      var observer = new MutationObserver(function () {
        window.clearTimeout(timer);
        timer = window.setTimeout(function () {
          refreshCheckoutButtons();
          applyLayout();
        }, 100);
      });
      observer.observe(payLive, { childList: true, subtree: true });
    }
  }

  function initSection(root) {
    if (!root) return;
    syncStickyOffsets();
    initStickyBar(root);

    if (!root.dataset.stickyOffsetInit) {
      root.dataset.stickyOffsetInit = 'true';
      window.addEventListener('resize', syncStickyOffsets);
    }

    if (root.dataset.customPdpInit === 'true') return;
    root.dataset.customPdpInit = 'true';

    var sectionId = root.dataset.sectionId;
    var dataEl =
      document.getElementById('custom-pdp-data-' + sectionId) ||
      root.querySelector('script[type="application/json"][id^="custom-pdp-data-"]');

    var data = {};
    if (dataEl) {
      try {
        data = JSON.parse(dataEl.textContent);
      } catch (e) {
        /* variant JSON failed — sticky still works */
      }
    }

    var variants = data.variants || [];
    var selectedOptions = (data.selectedOptions || []).slice();
    var qty = 1;

    var heroImg = root.querySelector('[data-hero-img]');
    var heroStack = root.querySelector('[data-hero-stack]');
    var thumbs = root.querySelector('[data-thumbs]');
    var priceNow = root.querySelector('[data-price-now]');
    var priceWas = root.querySelector('[data-price-was]');
    var priceSave = root.querySelector('[data-price-save]');
    var saveBadge = root.querySelector('[data-save-badge]');
    var atcPrice = root.querySelector('[data-atc-price]');
    var variantInput = root.querySelector('[data-variant-id]');
    var installmentVariantInput = root.querySelector('[data-installment-variant-id]');
    var installmentVariantSelect = root.querySelector('[data-installment-variant-select]');
    var qtyDisplay = root.querySelector('[data-qty-display]');
    var qtyInput = root.querySelector('[data-qty-input]');
    var addBtn = root.querySelector('[data-add-btn]');
    var productForm = root.querySelector('[data-product-form]');
    var stickyEl =
      document.querySelector('[data-sticky-for="' + sectionId + '"]') ||
      root.querySelector('[data-sticky]');
    var stImg = stickyEl && stickyEl.querySelector('[data-sticky-img]');
    var stPr = stickyEl && stickyEl.querySelector('[data-sticky-price]');
    var stSize = stickyEl && stickyEl.querySelector('[data-sticky-size]');
    var colorName = root.querySelector('[data-color-name]');
    var sizesWrap = root.querySelector('[data-sizes]');
    var swatchesWrap = root.querySelector('[data-swatches]');
    var jobsWrap = root.querySelector('[data-jobs]');
    var paymentWrap = root.querySelector('[data-payment-wrap]');
    var avadaColorValue = root.querySelector('[data-avada-color-value]');
    var avadaSizeValue = root.querySelector('[data-avada-size-value]');
    var avadaSizeVisible = root.querySelector('[data-avada-size-visible]');

    function syncInstallmentVariant(variantId) {
      var id = String(variantId);
      if (installmentVariantInput) {
        installmentVariantInput.value = id;
        installmentVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (installmentVariantSelect) {
        installmentVariantSelect.value = id;
        installmentVariantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function refreshPaymentButton() {
      if (typeof Shopify !== 'undefined' && Shopify.PaymentButton && typeof Shopify.PaymentButton.init === 'function') {
        Shopify.PaymentButton.init();
      }
    }

    function syncAvadaOptionLabels() {
      if (swatchesWrap && avadaColorValue) {
        var colorIdx = parseInt(swatchesWrap.dataset.optionIndex || '-1', 10);
        if (colorIdx >= 0 && selectedOptions[colorIdx]) {
          avadaColorValue.textContent = selectedOptions[colorIdx];
        }
      }
      if (sizesWrap && avadaSizeValue) {
        var sizeIdx = parseInt(sizesWrap.dataset.optionIndex || '-1', 10);
        if (sizeIdx >= 0 && selectedOptions[sizeIdx]) {
          avadaSizeValue.textContent = selectedOptions[sizeIdx];
        }
      }
      if (avadaSizeVisible && sizesWrap) {
        var visibleSizeIdx = parseInt(sizesWrap.dataset.optionIndex || '-1', 10);
        if (visibleSizeIdx >= 0 && selectedOptions[visibleSizeIdx]) {
          avadaSizeVisible.textContent = selectedOptions[visibleSizeIdx];
        }
      }
    }

    function findVariant() {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return opt === selectedOptions[i];
        });
      });
    }

    function dispatchVariantChange() {
      var variant = findVariant();
      if (!variant) return;

      if (variantInput) {
        variantInput.value = variant.id;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      syncInstallmentVariant(variant.id);
      if (productForm) {
        productForm.dispatchEvent(
          new CustomEvent('variant:change', {
            bubbles: true,
            detail: { variant: variant }
          })
        );
      }
    }

    function compactVariantOptionsLayout() {
      root.querySelectorAll(
        '.custom-pdp-variant-options .swatches__container, ' +
          '.custom-pdp-color-block .swatches__container, ' +
          '.custom-pdp-size-block .swatches__container, ' +
          '.custom-pdp-variant-options .swatches__option-name, ' +
          '.custom-pdp-color-block .swatches__option-name, ' +
          '.custom-pdp-size-block .swatches__option-name'
      ).forEach(function (el) {
        if (el.closest('.custom-pdp-variant-hooks')) return;
        el.style.setProperty('display', 'none', 'important');
        el.style.margin = '0';
        el.style.padding = '0';
        el.style.height = '0';
        el.style.overflow = 'hidden';
        el.setAttribute('aria-hidden', 'true');
      });

      var sizeLabelRow = root.querySelector('.custom-pdp-size-label-row');
      if (sizeLabelRow) {
        Array.from(sizeLabelRow.children).forEach(function (el) {
          if (
            el.matches('.custom-pdp-size-label') ||
            el.matches('[data-find-my-size]') ||
            el.matches('.visually-hidden')
          ) {
            return;
          }
          el.style.setProperty('display', 'none', 'important');
          el.style.margin = '0';
          el.style.height = '0';
          el.style.overflow = 'hidden';
          el.setAttribute('aria-hidden', 'true');
        });
      }

      return true;
    }

    function hideThirdPartySizeLinks() {
      compactVariantOptionsLayout();

      var avadaBtn = document.getElementById('Avada-SC-button');
      if (avadaBtn) {
        avadaBtn.style.display = 'none';
        avadaBtn.setAttribute('aria-hidden', 'true');
      }

      root.querySelectorAll('.custom-pdp-size-label-row a, .custom-pdp-size-label-row button').forEach(function (el) {
        if (el.matches('[data-find-my-size]')) return;
        var label = (el.textContent || '').toLowerCase();
        if (label.indexOf('what') !== -1 && label.indexOf('size') !== -1) {
          el.style.display = 'none';
          el.setAttribute('aria-hidden', 'true');
        }
      });
      return true;
    }

    function initSizeChartIntegration() {
      hideThirdPartySizeLinks();

      if (typeof MutationObserver !== 'undefined') {
        var avadaObserver = new MutationObserver(function () {
          hideThirdPartySizeLinks();
        });
        avadaObserver.observe(document.body, { childList: true, subtree: true });
      }

      var attempts = 0;
      var timer = window.setInterval(function () {
        hideThirdPartySizeLinks();
        if (++attempts >= 24) window.clearInterval(timer);
      }, 500);
    }

    function syncMeasurementIntegrations() {
      syncAvadaOptionLabels();
      dispatchVariantChange();
    }

    function variantForPartial(partial) {
      return variants.find(function (v) {
        return Object.keys(partial).every(function (key) {
          var idx = parseInt(key, 10);
          return v.options[idx] === partial[key];
        });
      });
    }

    function updateUI(changedOptionIndex) {
      var variant = findVariant();
      if (!variant) {
        if (addBtn) addBtn.disabled = true;
        return;
      }

      var moneyFormat = getMoneyFormat(data);

      if (variantInput) variantInput.value = variant.id;
      syncInstallmentVariant(variant.id);
      if (priceNow) setMoneyHtml(priceNow, variant.price, moneyFormat);
      if (atcPrice) setMoneyHtml(atcPrice, variant.price, moneyFormat);
      if (stPr) setMoneyHtml(stPr, variant.price, moneyFormat);

      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        var saveAmt = variant.compare_at_price - variant.price;
        var savePct = Math.round((saveAmt / variant.compare_at_price) * 100);
        if (priceWas) {
          setMoneyHtml(priceWas, variant.compare_at_price, moneyFormat);
          priceWas.style.display = 'inline-flex';
        }
        if (priceSave) {
          priceSave.innerHTML = 'You save ' + formatMoney(saveAmt, moneyFormat);
          priceSave.style.display = 'inline-flex';
        }
        if (saveBadge) {
          saveBadge.textContent = 'Save ' + savePct + '%';
          saveBadge.style.display = '';
        }
      } else {
        if (priceWas) priceWas.style.display = 'none';
        if (priceSave) priceSave.style.display = 'none';
        if (saveBadge) saveBadge.style.display = 'none';
      }

      if (addBtn) {
        addBtn.disabled = !variant.available;
        if (variant.available) {
          if (!addBtn.querySelector('[data-atc-price]')) {
            addBtn.innerHTML =
              '<span class="add-big__inner">' +
              '<span class="add-big__label">' +
              '<span class="add-big__icon" aria-hidden="true">🛒</span>' +
              '<span class="add-big__text">Add to cart</span>' +
              '</span>' +
              '<span class="add-big__sep" aria-hidden="true">—</span>' +
              '<span class="add-big__price" data-atc-price></span>' +
              '</span>';
          }
          var atcPriceEl = addBtn.querySelector('[data-atc-price]');
          if (atcPriceEl) {
            setMoneyHtml(atcPriceEl, variant.price, moneyFormat);
          }
        } else {
          addBtn.textContent = 'Sold out';
        }
      }

      if (paymentWrap) {
        paymentWrap.style.display = variant.available ? '' : 'none';
      }

      var sizeOptionIndex = sizesWrap
        ? parseInt(sizesWrap.dataset.optionIndex || '-1', 10)
        : -1;
      var sizeOnlyChange = changedOptionIndex === sizeOptionIndex;

      if (variant.featured_media_id && heroStack && !sizeOnlyChange) {
        var mediaPanel = heroStack.querySelector(
          '[data-hero-panel][data-media-id="' + variant.featured_media_id + '"]'
        );
        if (mediaPanel) {
          pickThumb(parseInt(mediaPanel.dataset.mediaIndex, 10));
        }
      } else if (variant.featured_media && heroImg && !sizeOnlyChange) {
        heroImg.src = variant.featured_media;
        heroImg.alt = variant.featured_media_alt || heroImg.alt;
      }

      if (stImg && heroImg && heroImg.src) stImg.src = heroImg.src;

      syncOptionUI();
      syncStickySize();
      refreshSizeAvailability();
      syncMeasurementIntegrations();
      refreshPaymentButton();
      if (root._updateStickyBar) root._updateStickyBar();
      if (root._syncBundleMain) root._syncBundleMain(variant);
      isolateMiskLayout(root);
    }

    function syncOptionUI() {
      if (swatchesWrap) {
        swatchesWrap.querySelectorAll('[data-option-value]').forEach(function (btn) {
          var idx = parseInt(btn.dataset.optionIndex, 10);
          btn.classList.toggle('on', selectedOptions[idx] === btn.dataset.optionValue);
        });
        if (colorName) {
          var colorBtn = swatchesWrap.querySelector('.sw.on');
          if (colorBtn) colorName.textContent = colorBtn.dataset.optionValue;
        }
      }
      if (sizesWrap) {
        sizesWrap.querySelectorAll('[data-option-value]').forEach(function (btn) {
          var idx = parseInt(btn.dataset.optionIndex, 10);
          btn.classList.toggle('on', selectedOptions[idx] === btn.dataset.optionValue);
        });
      }
    }

    function syncStickySize() {
      if (!stSize || !sizesWrap) return;
      var sizeBtn = sizesWrap.querySelector('.sz.on');
      if (!sizeBtn) {
        stSize.selectedIndex = 0;
        return;
      }
      var val = sizeBtn.dataset.optionValue;
      Array.prototype.forEach.call(stSize.options, function (opt) {
        opt.selected = opt.value === val;
      });
    }

    function refreshSizeAvailability() {
      if (!sizesWrap) return;
      var sizeIdx = parseInt(sizesWrap.dataset.optionIndex || '-1', 10);
      if (sizeIdx < 0) return;

      sizesWrap.querySelectorAll('[data-option-value]').forEach(function (btn) {
        var partial = {};
        for (var i = 0; i < selectedOptions.length; i++) {
          if (i === sizeIdx) {
            partial[i] = btn.dataset.optionValue;
          } else if (selectedOptions[i]) {
            partial[i] = selectedOptions[i];
          }
        }
        var v = variantForPartial(partial);
        btn.classList.toggle('unavailable', !!(v && !v.available));
        if (v && v.inventory_quantity != null && v.inventory_management && v.inventory_quantity > 0 && v.inventory_quantity <= 3) {
          btn.classList.add('low');
          btn.setAttribute('data-low-label', v.inventory_quantity + ' left');
        } else {
          btn.classList.remove('low');
          btn.removeAttribute('data-low-label');
        }
      });
    }

    function selectOption(index, value) {
      selectedOptions[index] = value;
      var variant = findVariant();
      if (!variant) {
        var fallback = variants.find(function (v) {
          return v.options[index] === value && v.available;
        }) || variants.find(function (v) {
          return v.options[index] === value;
        });
        if (fallback) selectedOptions = fallback.options.slice();
      }
      updateUI(index);
    }

    function pauseHeroVideos() {
      if (!heroStack) return;
      heroStack.querySelectorAll('video').forEach(function (video) {
        video.pause();
      });
      heroStack.querySelectorAll('iframe').forEach(function (iframe) {
        var original = iframe.dataset.originalSrc;
        if (original) {
          iframe.setAttribute('src', original);
        }
      });
    }

    function playHeroVideo(index) {
      pickThumb(index);
      if (!heroStack) return;
      var panel = heroStack.querySelector('[data-hero-panel][data-media-index="' + index + '"]');
      if (!panel) return;

      var video = panel.querySelector('video');
      if (video) {
        video.currentTime = 0;
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
        return;
      }

      var iframe = panel.querySelector('iframe');
      if (iframe) {
        var src = iframe.getAttribute('src') || '';
        if (!iframe.dataset.originalSrc) {
          iframe.dataset.originalSrc = src;
        }
        if (!/autoplay=1/.test(src)) {
          iframe.setAttribute('src', src + (src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1');
        }
      }
    }

    function updateWatchVideoButton(activeIndex) {
      var watchBtn = root.querySelector('[data-watch-video]');
      if (!watchBtn) return;
      var videoIndex = parseInt(watchBtn.dataset.videoIndex, 10);
      if (isNaN(videoIndex) || videoIndex < 0) return;
      watchBtn.hidden = activeIndex === videoIndex;
    }

    function pickThumb(index) {
      if (!thumbs) return;
      var thumbBtns = thumbs.querySelectorAll('[data-thumb-index]');
      if (!thumbBtns[index]) return;

      pauseHeroVideos();

      if (heroStack) {
        heroStack.querySelectorAll('[data-hero-panel]').forEach(function (panel, i) {
          var active = i === index;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      }

      thumbBtns.forEach(function (btn, i) {
        var active = i === index;
        btn.classList.toggle('on', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      var activePanel = heroStack && heroStack.querySelector('[data-hero-panel][data-media-index="' + index + '"]');
      var activeImg = activePanel && activePanel.querySelector('img');
      var thumbImg = thumbBtns[index].querySelector('img');
      if (activeImg) {
        if (!root.querySelector('[data-hero-img]') && activeImg.classList.contains('custom-pdp-hero-img')) {
          activeImg.setAttribute('data-hero-img', '');
        }
        heroImg = root.querySelector('[data-hero-img]') || activeImg;
      }
      if (stImg && thumbImg) stImg.src = thumbImg.src;

      if (thumbBtns[index].scrollIntoView) {
        thumbBtns[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }

      updateWatchVideoButton(index);
    }

    if (thumbs) {
      thumbs.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-thumb-index]');
        if (!btn) return;
        pickThumb(parseInt(btn.dataset.thumbIndex, 10));
      });
    }

    var watchVideoBtn = root.querySelector('[data-watch-video]');
    if (watchVideoBtn) {
      watchVideoBtn.addEventListener('click', function () {
        var videoIndex = parseInt(watchVideoBtn.dataset.videoIndex, 10);
        if (isNaN(videoIndex) || videoIndex < 0) return;
        playHeroVideo(videoIndex);
      });
      var activePanel = heroStack && heroStack.querySelector('[data-hero-panel].is-active');
      var activeIndex = activePanel ? parseInt(activePanel.dataset.mediaIndex, 10) : 0;
      if (!isNaN(activeIndex)) updateWatchVideoButton(activeIndex);
    }

    if (swatchesWrap) {
      swatchesWrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-option-value]');
        if (!btn) return;
        selectOption(parseInt(btn.dataset.optionIndex, 10), btn.dataset.optionValue);
      });
    }

    if (sizesWrap) {
      sizesWrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-option-value]');
        if (!btn || btn.classList.contains('unavailable')) return;
        selectOption(parseInt(btn.dataset.optionIndex, 10), btn.dataset.optionValue);
      });
    }

    if (jobsWrap) {
      jobsWrap.addEventListener('click', function (e) {
        var job = e.target.closest('[data-job]');
        if (!job) return;
        jobsWrap.querySelectorAll('[data-job]').forEach(function (el) {
          el.classList.remove('on');
        });
        job.classList.add('on');
        if (typeof root.syncJobToFitPurpose === 'function') {
          root.syncJobToFitPurpose(job.textContent || '');
        }
      });
    }

    initSizeChartModal(root);

    function isMadeToMeasureSelected() {
      if (!sizesWrap) return false;
      var on = sizesWrap.querySelector('.sz.on, [data-option-value].on');
      if (!on) return false;
      var label = String(on.dataset.optionValue || on.textContent || '').toLowerCase();
      return (
        label.indexOf('made to measure') !== -1 ||
        label.indexOf('made-to-measure') !== -1 ||
        label.indexOf('custom measure') !== -1
      );
    }

    function getVisibleMtmFields() {
      var slot = root.querySelector('[data-misk-slot]');
      if (!slot) return [];
      return Array.prototype.slice
        .call(
          slot.querySelectorAll(
            'input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]), textarea, select'
          )
        )
        .filter(function (el) {
          return !el.disabled && !el.hidden && el.offsetParent !== null;
        });
    }

    function validateMadeToMeasure(showErrors) {
      if (!isMadeToMeasureSelected()) return true;
      var valid = true;
      getVisibleMtmFields().forEach(function (field) {
        var empty = !(field.value || '').trim();
        if (showErrors) field.classList.toggle('is-invalid', empty);
        if (empty) valid = false;
      });
      if (!valid && showErrors) {
        var slot = root.querySelector('[data-misk-slot]');
        if (slot && slot.scrollIntoView) {
          slot.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }
      return valid;
    }

    root._validateMadeToMeasure = validateMadeToMeasure;

    var sectionDiscountCode = (data.bundleDiscountCode || '').trim();
    if (sectionDiscountCode) rememberBundleDiscountCode(sectionDiscountCode);

    if (productForm) {
      productForm.addEventListener(
        'submit',
        function (e) {
          if (!validateMadeToMeasure(true)) {
            e.preventDefault();
            e.stopImmediatePropagation();
            return;
          }

          e.preventDefault();
          e.stopImmediatePropagation();

          var formData = new FormData(productForm);
          var payload = {
            id: parseInt(formData.get('id'), 10),
            quantity: parseInt(formData.get('quantity'), 10) || 1
          };
          if (!payload.id) return;

          var properties = {};
          formData.forEach(function (value, key) {
            var match = String(key).match(/^properties\[(.+)\]$/);
            if (match && String(value).trim()) properties[match[1]] = String(value);
          });
          if (Object.keys(properties).length) payload.properties = properties;

          var addBtnEl = root.querySelector('[data-add-btn]');
          if (addBtnEl) addBtnEl.disabled = true;

          fetch(cartRootPath().replace(/\/?$/, '/') + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ items: [payload] })
          })
            .then(function (res) {
              return res.json().then(function (body) {
                if (!res.ok) throw body;
                return body;
              });
            })
            .then(function () {
              return navigateWithBundleDiscount('/cart', sectionDiscountCode || getRememberedBundleDiscountCode());
            })
            .then(function (usedDiscount) {
              if (!usedDiscount) return goToCartOrDrawer();
            })
            .catch(function () {
              if (typeof productForm.submit === 'function') productForm.submit();
            })
            .finally(function () {
              if (addBtnEl) addBtnEl.disabled = false;
            });
        },
        true
      );
    }

    var bundleHelpers = {};
    initBundle(root, data, bundleHelpers);
    if (bundleHelpers.syncMainProduct) {
      root._syncBundleMain = bundleHelpers.syncMainProduct;
    }

    initFitCalculator(root, data, {
      selectOption: selectOption,
      pickThumb: pickThumb,
      sizesWrap: sizesWrap
    });

    initPaymentRow(root);

    root.querySelectorAll('[data-qty-minus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        qty = Math.max(1, qty - 1);
        if (qtyDisplay) qtyDisplay.textContent = qty;
        if (qtyInput) qtyInput.value = qty;
      });
    });

    root.querySelectorAll('[data-qty-plus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        qty += 1;
        if (qtyDisplay) qtyDisplay.textContent = qty;
        if (qtyInput) qtyInput.value = qty;
      });
    });

    if (stSize) {
      stSize.addEventListener('change', function () {
        if (!stSize.value || !sizesWrap) return;
        var sizeIdx = parseInt(sizesWrap.dataset.optionIndex || '-1', 10);
        if (sizeIdx >= 0) selectOption(sizeIdx, stSize.value);
      });
    }

    hookCurrencyRefresh(function () {
      updateUI();
    });
    document.addEventListener('currency:changed', function () {
      updateUI();
    });

    updateUI();
    initSizeChartIntegration();
    initMiskLayoutWatch(root);
    refreshPaymentButton();
  }

  function boot() {
    document.querySelectorAll('.custom-pdp[data-section-id]').forEach(initSection);
    initCartCheckoutBundleGate();
  }

  function initCartCheckoutBundleGate() {
    if (document.documentElement.dataset.bundleCheckoutGate === 'true') return;
    document.documentElement.dataset.bundleCheckoutGate = 'true';

    document.addEventListener(
      'click',
      function (e) {
        var btn = e.target.closest('#checkout, input[name="checkout"], button[name="checkout"]');
        if (!btn) return;

        e.preventDefault();
        e.stopPropagation();

        var code = getRememberedBundleDiscountCode();
        navigateWithBundleDiscount('/checkout', code)
          .then(function (usedDiscount) {
            if (usedDiscount) return;
            var form = btn.form || btn.closest('form');
            if (form) {
              var hidden = document.createElement('input');
              hidden.type = 'hidden';
              hidden.name = 'checkout';
              hidden.value = btn.value || 'Checkout';
              form.appendChild(hidden);
              form.submit();
            } else {
              window.location.href = cartRootPath().replace(/\/?$/, '/') + 'checkout';
            }
          })
          .catch(function () {
            window.location.href = cartRootPath().replace(/\/?$/, '/') + 'checkout';
          });
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = document.querySelector('#custom-pdp-' + e.detail.sectionId);
    if (root) {
      root.dataset.stickyBarInit = '';
      root.dataset.customPdpInit = '';
      initSection(root);
    }
  });

  /* Cart page may not load custom-pdp.js — gate is also inlined from cart-form when needed */
  window.MissLeatherBundleDiscount = {
    cartHasBundle: cartHasBundle,
    fetchCart: fetchCart,
    navigateWithBundleDiscount: navigateWithBundleDiscount,
    getRememberedBundleDiscountCode: getRememberedBundleDiscountCode,
    discountRedirectUrl: discountRedirectUrl
  };
})();
